var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNoTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 112,
    viewBox: "0 0 118 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4753 42.98C71.0953 43.03 62.5853 42.64 54.6153 40.42C46.6453 38.2 39.6153 34.04 33.2153 29.17C29.0153 26 25.2153 23.48 19.7653 23.86C14.445 24.1417 9.35698 26.1299 5.25526 29.53C-1.67474 35.59 -0.624743 46.75 2.13526 54.68C6.30526 66.55 18.9753 74.75 29.7253 80.17C42.1553 86.38 55.8053 89.98 69.5053 92.06C81.5053 93.88 96.9153 95.21 107.315 87.37C116.875 80.17 119.495 63.73 117.155 52.63C116.585 49.3468 114.835 46.3847 112.235 44.3C105.525 39.4 95.5153 42.67 87.9753 42.84C85.1753 42.9 82.3353 42.96 79.4753 42.98Z",
    fill: "#41446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9849 111.51C79.2593 111.51 95.6949 110.485 95.6949 109.22C95.6949 107.955 79.2593 106.93 58.9849 106.93C38.7105 106.93 22.2749 107.955 22.2749 109.22C22.2749 110.485 38.7105 111.51 58.9849 111.51Z",
    fill: "#41446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5049 30.76V35.07",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3452 32.92H98.6552",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2749 66.98V71.28",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 69.13H26.435",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2451 12.84V17.14",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0952 14.99H20.3952",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1152 2.85002C65.6565 2.85002 66.0953 2.41126 66.0953 1.87002C66.0953 1.32878 65.6565 0.890015 65.1152 0.890015C64.574 0.890015 64.1353 1.32878 64.1353 1.87002C64.1353 2.41126 64.574 2.85002 65.1152 2.85002Z",
    fill: "#5E628C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7652 98.46C63.3064 98.46 63.7452 98.0212 63.7452 97.48C63.7452 96.9388 63.3064 96.5 62.7652 96.5C62.2239 96.5 61.7852 96.9388 61.7852 97.48C61.7852 98.0212 62.2239 98.46 62.7652 98.46Z",
    fill: "#5E628C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8119 7.53514L26.7787 13.4591C25.4768 13.5944 24.531 14.7594 24.6662 16.0613L32.4664 91.1573C32.6016 92.4592 33.7667 93.405 35.0686 93.2698L92.1017 87.3458C93.4036 87.2105 94.3494 86.0455 94.2142 84.7436L86.414 9.6476C86.2788 8.34569 85.1138 7.39991 83.8119 7.53514Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3577 11.0115L29.8847 16.3579C28.5827 16.4932 27.637 17.6582 27.7722 18.9601L34.8264 86.8747C34.9617 88.1766 36.1267 89.1224 37.4286 88.9872L88.9017 83.6407C90.2036 83.5055 91.1494 82.3405 91.0141 81.0385L83.9599 13.1239C83.8247 11.822 82.6597 10.8762 81.3577 11.0115Z",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4851 14.33L71.6851 6.62999C71.6689 6.46906 71.6211 6.3129 71.5444 6.17047C71.4677 6.02805 71.3637 5.90214 71.2383 5.79996C71.1129 5.69779 70.9686 5.62135 70.8136 5.57502C70.6586 5.5287 70.496 5.5134 70.3351 5.52999L60.7851 6.52999C60.5768 5.02105 59.7901 3.65218 58.5911 2.71257C57.3922 1.77297 55.875 1.33622 54.36 1.4946C52.845 1.65298 51.4509 2.39408 50.4722 3.56134C49.4935 4.7286 49.0069 6.23059 49.1151 7.74999L39.5551 8.74999C39.3946 8.76618 39.2388 8.81406 39.0969 8.89087C38.955 8.96767 38.8297 9.07187 38.7283 9.19743C38.6269 9.32299 38.5515 9.46742 38.5063 9.62235C38.4611 9.77727 38.4471 9.93962 38.4651 10.1L39.2651 17.8C39.2814 17.9609 39.3292 18.1171 39.4059 18.2595C39.4826 18.4019 39.5866 18.5278 39.712 18.63C39.8374 18.7322 39.9817 18.8086 40.1367 18.855C40.2916 18.9013 40.4542 18.9166 40.6151 18.9L71.3951 15.7C71.5571 15.6826 71.714 15.6333 71.8567 15.5548C71.9994 15.4763 72.1251 15.3703 72.2265 15.2428C72.3279 15.1154 72.403 14.969 72.4474 14.8123C72.4918 14.6556 72.5046 14.4917 72.4851 14.33Z",
    fill: "#5E628C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6675 48.727C72.5568 51.7064 71.4308 54.5584 69.4762 56.8098C67.5217 59.0612 64.8562 60.5767 61.9219 61.1048C58.9876 61.633 55.9609 61.1421 53.344 59.7135C50.7271 58.2849 48.6773 56.0046 47.5346 53.2508",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1853 38.37L44.4053 44.27",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8452 38.9301L49.7452 43.7101",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3449 35.97L67.5649 41.86",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0049 36.52L72.9049 41.31",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoTask);
export default __webpack_public_path__ + "static/media/EmptyState-NoTask.044b1050327f767b70682e0a94fd822c.svg";
export { ForwardRef as ReactComponent };